import { catToBucket } from '../types/cost.js';
import { persoonOpDatum } from './koppeling.js';
import { normPlate } from './plate.js';
/**
 * The cost lines attributed to one person: transactions whose card was held by
 * that person on the transaction date. Generic so it preserves the full line
 * shape (categorie, bedrag, etc.) for further per-category/month aggregation.
 */
export function costLinesVoorPersoon(lines, koppelingen, persoonId) {
    return lines.filter((r) => r.cardId != null && persoonOpDatum(koppelingen, r.cardId, r.datum) === persoonId);
}
/**
 * Total cost (excl. VAT) per person, attributing each transaction to whoever
 * held its card on the transaction date. Optionally restricted to one month.
 * Lines whose card/date maps to no person fall under the `null` key
 * ("ongekoppeld").
 */
export function costsPerPersoon(lines, koppelingen, month) {
    const out = new Map();
    for (const r of lines) {
        if (month && r.maand !== month)
            continue;
        const persoonId = r.cardId ? persoonOpDatum(koppelingen, r.cardId, r.datum) : null;
        out.set(persoonId, (out.get(persoonId) ?? 0) + (Number(r.bedragExcl) || 0));
    }
    return out;
}
export function emptyBuckets() {
    return { brandstof: 0, laden: 0, parkeren: 0, wassen: 0, onderhoud: 0, overige: 0 };
}
/**
 * Total cost (excl. VAT) for a plate, optionally restricted to one `YYYY-MM`
 * month. Ported from the prototype `costsFor`.
 */
export function costsFor(lines, kenteken, month) {
    const k = normPlate(kenteken);
    let sum = 0;
    for (const r of lines) {
        if (normPlate(r.kenteken) === k && (!month || r.maand === month)) {
            sum += Number(r.bedragExcl) || 0;
        }
    }
    return sum;
}
/**
 * All-time total (excl. VAT) for one rollup group over the given lines. Unlike
 * `catBreakdown` this is not scoped to a month or a plate, so pass lines that
 * are already narrowed down — e.g. the cost lines of a single car.
 */
export function bucketTotaal(lines, bucket) {
    let sum = 0;
    for (const r of lines) {
        if (catToBucket(r.categorie) === bucket)
            sum += Number(r.bedragExcl) || 0;
    }
    return sum;
}
/** Sorted list of distinct `YYYY-MM` months present in the cost lines. */
export function allMonths(lines) {
    const s = new Set();
    for (const r of lines)
        if (r.maand)
            s.add(r.maand);
    return Array.from(s).sort();
}
/** Per-group totals for one plate in one month. */
export function catBreakdown(lines, kenteken, month) {
    const k = normPlate(kenteken);
    const b = emptyBuckets();
    for (const r of lines) {
        if (normPlate(r.kenteken) !== k || r.maand !== month)
            continue;
        b[catToBucket(r.categorie)] += Number(r.bedragExcl) || 0;
    }
    return b;
}
/** Per-group totals for a given month across ALL plates. */
export function monthBuckets(lines, month) {
    const b = emptyBuckets();
    for (const r of lines) {
        if (r.maand !== month)
            continue;
        b[catToBucket(r.categorie)] += Number(r.bedragExcl) || 0;
    }
    return b;
}
//# sourceMappingURL=costs.js.map